/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How the prize reveal is staged for a spin-to-win game.
 * @export
 */
export const PrizeRevealMethod = {
    SINGLE_WHEEL_PRIZE_REVEAL: 'SINGLE_WHEEL_PRIZE_REVEAL',
    DOUBLE_WHEEL_PRIZE_REVEAL: 'DOUBLE_WHEEL_PRIZE_REVEAL',
    unknown_default_open_api: '11184809'
} as const;
export type PrizeRevealMethod = typeof PrizeRevealMethod[keyof typeof PrizeRevealMethod];


export function instanceOfPrizeRevealMethod(value: any): boolean {
    for (const key in PrizeRevealMethod) {
        if (Object.prototype.hasOwnProperty.call(PrizeRevealMethod, key)) {
            if (PrizeRevealMethod[key as keyof typeof PrizeRevealMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PrizeRevealMethodFromJSON(json: any): PrizeRevealMethod {
    return PrizeRevealMethodFromJSONTyped(json, false);
}

export function PrizeRevealMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizeRevealMethod {
    return json as PrizeRevealMethod;
}

export function PrizeRevealMethodToJSON(value?: PrizeRevealMethod | null): any {
    return value as any;
}

